module.exports = __webpack_public_path__ + "static/media/hab2-2.8c9de73c.jpg";